<template>
    <form >
        <ui-menu-card
            icon="fal fa-cog"
            icon-size="20"
        >
            <div v-if="userLoggedGroup == 'admin'">
                <ui-button style="width: 100%" @click="setManager('old')"> Usar Versão Antiga </ui-button>
            </div>
            <div v-if="userLoggedGroup == 'admin'">
                <ui-button style="width: 100%" @click="setManager('remove')"> Excluir Usuário </ui-button>
            </div>
            <div>
                <ui-button  style="width: 100%" @click="setManager('salvar')"> Modificar Perfil </ui-button>
            </div>
            <div v-if="user.user_group == 'broker' || user.user_group == 'manager' || user.user_group == 'supervisor'">
                <ui-button  style="width: 100%" @click="setManager('equipe')"> Equipe </ui-button>
            </div>
            <div class="separator"/>
            <div class="switch">
                <ui-switch
                    id="blockUser"
                    :checked="!user.status == 'active'"
                    :label="status.msg"
                    name="remember"
                    design="sm"
                    @click="bloquear(status.status)" />
            </div>
        </ui-menu-card>
        <modal-manager :item="data" :user="user" @close="close()"/>
    </form>
</template>


<script>
import { uiMenuCard } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiSwitch } from '@/components/ui/form'
import modalManager from './modal-manager'

import { helpersMixin } from '@/mixins'

export default {
    name: 'ui-user-manager',
    components: {
        uiButton,
        uiSwitch,
        uiMenuCard,
        modalManager
    },

    mixins: [helpersMixin],

    props: {
        dinamics: {
            type: [Array, Object],
            default: () => []
        },
        userLoggedGroup: {
            type: String,
            default: ''
        },
        user: {
            type: [Object, String],
            default: ''
        },
        groups: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            data: {
                msg: '',
                id: '',
                title: '',
                icon: '',
                type: '',
                user: '',
                group: '',
            }
        }
    },

    computed: {
        status() {
            return this.user && this.user.status == 'active' ? {msg: 'Bloquear Usuário', icon: 'fas fa-user-lock', status: "inactive"} : {msg: 'Desbloquear Usuário', icon: 'fas fa-user-unlock', status: "active"}
        }
    },
    methods: {
        setManager(set) {
            this.data.id    = this.user && this.user.id ? this.user.id : ''
            this.data.user  = this.user && this.user.first_name ? this.returnName(this.user.first_name) : ''
            this.data.group = this.user && this.user.user_group ? this.user.user_group : ''
            this.data.data  = { data: this.groups, dinamics: this.dinamics}
            switch (set) {
                case 'remove':
                    this.data.title = "Remover Usuário"
                    this.data.icon  = "fal fa-user"
                    this.data.type  = 'remove'
                    break
                case 'salvar':
                    this.data.title = "Modificar Perfil"
                    this.data.icon = "fad fa-users-cog"
                    this.data.type = 'edit'
                    break
                case 'equipe':
                    this.data.title = "Equipe"
                    this.data.icon = "fad fa-users-class"
                    this.data.type = 'equipe'
                    break
                case 'old':
                    this.$mx_oldPanelLinkButton(`perfil/${this.user.id}`)
            }
            if (set !== 'old') this.$root.$emit('modal-open-user-manager-profile')
        },
        returnName(name) {
            let setName = name.split(" ")
            let transformName = []
            let newName = null
            setName.forEach(element => {
                if(element && element.length > 2) {
                    var nameUpperCase = element.toLowerCase()
                    transformName.push(nameUpperCase[0].toUpperCase() + nameUpperCase.substr(1))
                }
                else {
                    transformName.push(element)
                }
            });
            newName = transformName.join(" ")
            return newName
        },
        close() {
            this.$root.$emit('modal-close-user-manager-profile')
        },
        bloquear(block) {
            this.$emit('imput', block)
        }
    }
}
</script>

<style lang='stylus' scoped>
    form
        padding-right: 30px;
        div
            display: flex
            align-items: center
            justify-content: center
            p
                font-size: 13px
                color: #4a586c
            i
                font-size 13px
        .separator
            margin-bottom: 20px
            width: 100%
            position absolute
            right: 1px
            border-top: 1px solid #e6e6f3
        .switch
            padding-top: 20px

</style>